const API_URL = 'https://api.amark.pro';
// const API_URL = 'http://localhost:8000';
const DEBUG_MODE = false;

export {API_URL, DEBUG_MODE};